import React, { useState } from 'react';
import { Twitter, Send, ExternalLink, Copy, Check } from 'lucide-react';
import siteConfig from '../config/contentConfig';
import { toast } from 'sonner';

const Footer = () => {
  const [copied, setCopied] = useState(false);

  const copyContractAddress = () => {
    navigator.clipboard.writeText(siteConfig.token.contractAddress);
    setCopied(true);
    toast.success('🍌 Contract address copied!');
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <footer
      data-testid="footer-section"
      className="bg-[#141822] border-t border-yellow-500/20"
    >
      <div className="section-container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <img
                src={siteConfig.images.floatingBanana}
                alt="$NANA Logo"
                className="h-12 w-12"
              />
              <span className="text-2xl font-black text-[#32B44A]">
                {siteConfig.token.symbol}
              </span>
            </div>
            <p className="text-slate-400 text-sm">
              {siteConfig.brand.footerTagline}
            </p>
          </div>

          {/* Navigation Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Navigation</h4>
            <ul className="space-y-2">
              {siteConfig.navigation.map((item) => (
                <li key={item.id}>
                  <a
                    href={item.href}
                    className="text-slate-400 hover:text-[#FFD600] transition-colors"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Community Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Community</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={siteConfig.links.twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-twitter-link"
                  className="flex items-center space-x-2 text-slate-400 hover:text-[#FFD600] transition-colors"
                >
                  <Twitter size={18} />
                  <span>{siteConfig.social.twitter}</span>
                </a>
              </li>
              <li>
                <a
                  href={siteConfig.links.telegram}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-telegram-link"
                  className="flex items-center space-x-2 text-slate-400 hover:text-[#FFD600] transition-colors"
                >
                  <Send size={18} />
                  <span>Telegram</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Useful Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Useful Links</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={siteConfig.links.buyNana}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-slate-400 hover:text-[#FFD600] transition-colors"
                >
                  <ExternalLink size={18} />
                  <span>Buy $NANA</span>
                </a>
              </li>
              <li>
                <a
                  href={siteConfig.links.suprascan}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-slate-400 hover:text-[#FFD600] transition-colors"
                >
                  <ExternalLink size={18} />
                  <span>Supra Explorer</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Contract Address */}
        <div className="border-t border-yellow-500/20 pt-8 mb-8">
          <div className="max-w-4xl mx-auto">
            <h4 className="text-center text-sm font-semibold text-slate-400 mb-3">
              Contract Address
            </h4>
            <div className="glass rounded-xl p-4 flex items-center justify-between flex-wrap gap-4">
              <code
                data-testid="footer-contract-address"
                className="font-mono text-xs sm:text-sm text-slate-300 break-all"
              >
                {siteConfig.token.contractAddress}
              </code>
              <button
                data-testid="footer-copy-contract-btn"
                onClick={copyContractAddress}
                className="flex items-center space-x-2 px-4 py-2 bg-[#FFD600] hover:bg-[#FFE033] text-black font-semibold rounded-lg btn-press transition-colors flex-shrink-0"
              >
                {copied ? <Check size={16} /> : <Copy size={16} />}
                <span>{copied ? 'Copied!' : 'Copy'}</span>
              </button>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-yellow-500/20 pt-8 text-center">
          <p className="text-slate-400 text-sm">
            © 2025 {siteConfig.token.symbol} | Built on {siteConfig.token.blockchain} 🍌
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
